import Layout from './Layout'
import './Layout.css'

export default Layout



// WEBPACK FOOTER //
// ./src/features/Personal/containers/Layout/index.js